import styled from 'styled-components';
import CopyField from '../../../CopyField';

const StyledInvoiceForward = styled.div`
  color: ${props => props.theme.colors.neutral_8};
  background-color: ${props => props.theme.colors.neutral_3};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 22px;
  padding: 6px 48px;
  min-height: 70px;
  p {
    margin: 0 16px 0 0;
  }
`;

const StyledCopyField = styled(CopyField)`
  border-radius: ${props => props.theme.border_radius.standard};
  min-width: 200px;
  max-width: 350px;
  width: auto;
  
  & * {
    font-size: 14px;
  }
`;

export {
  StyledInvoiceForward,
  StyledCopyField
};
